// @flow

import { type Merchant } from '@tectonics/prs/merchant/types';

export function getGoogleAnalyticsTrackingSite(merchant: Merchant): ?string {
  return merchant['google_analytics_tracking_site'];
}
